module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8503/img/blobsLeft.png"